import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'

export default function InitialStepChatClosed({
    inboxes = [],
    chatIntents = [],
    stepOptions = {},
    inputProps = {},
    updateValue = () => {}
}) {
    const beta = useSelector((state) => state.accountMaster.accountMaster.beta)
    const [fields, setFields] = useState(null)

    useEffect(() => {
        if (stepOptions.InboxId?.value > -1) {
            setFields(null)
            axios.get('/inboxes/' + stepOptions.InboxId.value + '/field').then(({ data }) => {
                setFields(data)
            })
        } else {
            setFields([])
        }
    }, [stepOptions.InboxId?.value])

    useEffect(() => {
        // clear any stepOptions.customFieldFilters.value that are no longer valid (dont exist for this inbox)
        if (fields && Array.isArray(stepOptions.customFieldFilters?.value)) {
            const validFieldIds = fields.map((f) => f.id)
            const newFilters = stepOptions.customFieldFilters.value.filter((f) => validFieldIds.includes(f.field))
            if (newFilters.length !== stepOptions.customFieldFilters.value.length) {
                updateValue({
                    target: {
                        name: 'customFieldFilters',
                        value: newFilters
                    }
                })
            }
        }
    }, [fields])

    const chatIntentTypes = []
    for (const row of chatIntents) {
        if (row.ChatIntentTypeId && !chatIntentTypes.some((t) => t.id === row.ChatIntentTypeId)) {
            chatIntentTypes.push(row.ChatIntentType)
        }
    }

    const users = []
    for (const inbox of inboxes) {
        if (stepOptions.InboxId?.value > -1 && inbox.id !== stepOptions.InboxId?.value) {
            continue
        }
        for (const user of inbox.AccountUsers) {
            if (!users.some((u) => u.value === user.id)) {
                users.push({
                    value: user.id,
                    label: user.firstName + ' ' + user.lastName + ' (' + user.emailAddress + ')'
                })
            }
        }
    }

    const addCustomFieldFilter = () => {
        const newFilters = stepOptions.customFieldFilters ? [...stepOptions.customFieldFilters.value] : []
        newFilters.push({ field: '', operator: 'equals', value: '' })
        updateValue({
            target: {
                name: 'customFieldFilters',
                value: newFilters
            }
        })
        return newFilters.length - 1
    }

    const removeCustomFieldFilter = (index) => {
        const newFilters = [...stepOptions.customFieldFilters.value]
        newFilters.splice(index, 1)
        updateValue({
            target: {
                name: 'customFieldFilters',
                value: newFilters
            }
        })
    }

    const updateCustomFieldFilter = (index, field, value) => {
        const newFilters = [...stepOptions.customFieldFilters.value]
        newFilters[index][field] = value
        updateValue({
            target: {
                name: 'customFieldFilters',
                value: newFilters
            }
        })
    }

    return (
        <div>
            <Select
                filter={true}
                updateFilter={() => {}}
                label='Inbox'
                data={[{ label: 'All Inboxes', value: -1 }].concat(
                    inboxes.map((i) => ({ label: i.name, value: i.id }))
                )}
                value={stepOptions.InboxId?.value}
                name='InboxId'
                onChange={updateValue}
                outerClassName='mar-b10'
                {...inputProps}
            />
            {stepOptions.InboxId?.value > -1 && (
                <Select
                    filter={true}
                    updateFilter={() => {}}
                    label='Channel'
                    data={[{ label: 'All Channels', value: -1 }].concat(
                        inboxes
                            .find((i) => i.id === stepOptions.InboxId.value)
                            ?.InboxChannels?.map((i) => ({ label: i.name, value: i.id }))
                    )}
                    value={stepOptions.InboxChannelId?.value}
                    name='InboxChannelId'
                    onChange={updateValue}
                    outerClassName='mar-b10'
                    {...inputProps}
                />
            )}
            {beta.sentimentAnalysis && (
                <>
                    <Select
                        label='Sentiment'
                        data={[
                            { label: 'Any Sentiment', value: null },
                            { label: 'Positive', value: 1 },
                            { label: 'Neutral', value: 0 },
                            { label: 'Negative', value: -1 }
                        ]}
                        value={stepOptions.sentiment?.value}
                        name='sentiment'
                        onChange={updateValue}
                        outerClassName='mar-b10'
                        {...inputProps}
                    />
                    <Select
                        label='Intent Category'
                        data={[{ label: 'Any Categories', value: -1 }].concat(
                            chatIntentTypes.map((i) => ({ label: i.name, value: i.id }))
                        )}
                        value={stepOptions.ChatIntentTypeId?.value}
                        name='ChatIntentTypeId'
                        onChange={updateValue}
                        outerClassName='mar-b10'
                        filter={true}
                        updateFilter={() => {}}
                        {...inputProps}
                    />
                    <Select
                        label='Intent'
                        data={[{ label: 'Any Intent', value: -1 }].concat(
                            chatIntents
                                .filter((ci) => {
                                    if (stepOptions.ChatIntentTypeId?.value > -1) {
                                        return ci.ChatIntentTypeId === stepOptions.ChatIntentTypeId.value
                                    } else {
                                        return true
                                    }
                                })
                                .map((i) => ({
                                    group:
                                        stepOptions.ChatIntentTypeId?.value === -1 ? i.ChatIntentType?.name : undefined,
                                    label: i.name,
                                    value: i.id
                                }))
                        )}
                        value={stepOptions.ChatIntentId?.value}
                        name='ChatIntentId'
                        onChange={updateValue}
                        outerClassName='mar-b10'
                        filter={true}
                        updateFilter={() => {}}
                        {...inputProps}
                    />
                </>
            )}
            <Select
                filter={true}
                updateFilter={() => {}}
                value={stepOptions.AssignedUserId?.value}
                name='AssignedUserId'
                onChange={updateValue}
                label='Assigned User'
                data={[{ label: 'Any User', value: -1 }].concat(users)}
                outerClassName='mar-b10'
                {...inputProps}
            />
            {stepOptions.InboxId?.value > -1 && !fields && <LoadingIcons />}
            {!!fields?.length && (
                <div>
                    <label className='txtInput_label'>Inbox Field Filters</label>
                    <ChatFieldFilters
                        filters={stepOptions.customFieldFilters?.value || []}
                        fields={fields}
                        addFilter={addCustomFieldFilter}
                        removeFilter={removeCustomFieldFilter}
                        updateFilter={updateCustomFieldFilter}
                    />
                </div>
            )}
        </div>
    )
}

function ChatFieldFilters({ filters, fields, addFilter, removeFilter, updateFilter }) {
    const [adding, setAdding] = useState(-1)

    if (adding > -1) {
        const filter = filters[adding]
        if (!filter) return null
        const field = fields.find((f) => f.id === filter.field)
        return (
            <>
                <Select
                    filter={true}
                    updateFilter={() => {}}
                    label={`Field`}
                    data={fields.map((f) => ({ label: f.name, value: f.id }))}
                    value={filter.field}
                    onChange={(ev) => updateFilter(adding, 'field', ev.target.value)}
                    outerClassName='mar-b10'
                />

                <FieldOperator
                    field={field}
                    operator={filter.operator}
                    setOperator={(value) => updateFilter(adding, 'operator', value)}
                />
                <FieldValue
                    field={field}
                    operator={filter.operator}
                    value={filter.value}
                    setValue={(value) => updateFilter(adding, 'value', value)}
                />
                <div className='quickFlex' style={{ gap: 5 }}>
                    <Button text='Save' className='button-sml' onClick={() => setAdding(-1)} />
                    <Button
                        text='Remove'
                        className='button-grey button-sml'
                        onClick={() => {
                            setAdding(-1)
                            removeFilter(adding)
                        }}
                    />
                </div>
            </>
        )
    }

    return (
        <div>
            <div className='mar-b10'>
                {filters.map((filter, index) => {
                    const field = fields.find((f) => f.id === filter.field)
                    const fieldLabel = field ? field.name : 'NOT FOUND'
                    return (
                        <SquareChip
                            key={index}
                            className='square-chip-purple mar-r5 mar-b5'
                            value={`${fieldLabel} ${filter.operator} "${filter.value}"`}
                            onClick={() => setAdding(index)}
                        />
                    )
                })}
            </div>
            <Button
                className='button-sml button-primary'
                text={filters.length ? 'Add another Filter' : 'Add a Filter'}
                onClick={() => {
                    const index = addFilter()
                    setAdding(index)
                }}
            />
        </div>
    )
}

function FieldOperator({ field, operator, setOperator }) {
    if (!field) return null
    const operatorsByType = {
        text: [
            { label: 'Equals', value: 'equals' },
            { label: 'Does Not Equal', value: 'not equals' },
            { label: 'Contains', value: 'contains' },
            { label: 'Does Not Contain', value: 'not contains' },
            { label: 'Is Blank', value: 'is blank' },
            { label: 'Is Not Blank', value: 'is not blank' }
        ],
        select: [
            { label: 'Equals', value: 'equals' },
            { label: 'Does Not Equal', value: 'not equals' }
        ],
        date: [
            { label: 'Is On', value: 'is on' },
            { label: 'Is Before', value: 'is before' },
            { label: 'Is After', value: 'is after' }
        ],
        number: [
            { label: 'Equals', value: 'equals' },
            { label: 'Does Not Equal', value: 'not equals' },
            { label: 'Is Greater Than', value: 'greater than' },
            { label: 'Is Less Than', value: 'less than' }
        ],
        boolean: [
            { label: 'Is', value: 'equals' },
            { label: 'Is Not', value: 'not equals' }
        ]
    }
    const operators = operatorsByType[field.type] || []

    if (!operators.length) return null

    return (
        <Select
            label='Operator'
            data={operators}
            value={operator}
            onChange={(ev) => setOperator(ev.target.value)}
            outerClassName='mar-b10'
        />
    )
}

function FieldValue({ field, operator, value, setValue }) {
    if (!field) return null
    if (operator === 'is blank' || operator === 'is not blank') return null

    if (field.type === 'select') {
        return (
            <Select
                label='Value'
                data={field.options}
                value={value}
                onChange={(ev) => setValue(ev.target.value)}
                outerClassName='mar-b10'
            />
        )
    } else if (field.type === 'date') {
        return (
            <TextInput
                type='date'
                label='Value'
                value={value}
                onChange={(e, d) => setValue(d)}
                outerClassName='mar-b10'
            />
        )
    } else if (field.type === 'boolean') {
        return (
            <Select
                label='Value'
                data={[
                    { label: 'True', value: true },
                    { label: 'False', value: false }
                ]}
                value={value}
                onChange={(ev) => setValue(ev.target.value)}
                outerClassName='mar-b10'
            />
        )
    } else if (field.type === 'number') {
        return (
            <TextInput
                type='number'
                label='Value'
                value={value}
                onChange={(ev) => setValue(Number(ev.target.value))}
                outerClassName='mar-b10'
            />
        )
    } else {
        return (
            <TextInput
                label='Value'
                value={value}
                onChange={(ev) => setValue(ev.target.value)}
                outerClassName='mar-b10'
            />
        )
    }
}
